

  // console.log('cart check');
  //     if (window.location.pathname === "/cart") {
  //     // Redirect the user to the homepage
  //     window.location.href = "/";
  //   }

$(document).ready(function () {
  // if (document.referrer.includes("/cart")) {
  //     // Run your function here
  //     console.log('just came from cart');
  //      setTimeout(showCart, 1000);

  //     function showCart() {

  //       window.Rebuy.SmartCart.show();
  //     }
  //   }
  
  // Slick Announcements
  $('#shopify-section-announcement-bar').slick({
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: false,
    });

  $( document ).ready(function(e) {
var windowWidthSize = $(window).width();

if( windowWidthSize < 1025 ){

   $('.sliderVideoAuto').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: true,
      dots: true,
      autoplaySpeed: 3500,
       responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 585,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
}

});





  
  

  		 $(window).on("resize", function (e) {
      	  checkScreenSize();
   		 });

   	 checkScreenSize();

    function checkScreenSize(){
        var newWindowWidth = $(window).width();

        if (newWindowWidth < 640) {
                        $('.facet-filters__label:contains(Sort by:)').text('Sort by');
                var Scrollbar = window.Scrollbar;
          
      		Scrollbar.init(document.querySelector('ul.slider'));

            if($('ul.multicolumn-list').length) {
              Scrollbar.init(document.querySelector('ul.multicolumn-list'));  
            }
            if($('ul.metas-products').length) {
              Scrollbar.init(document.querySelector('ul.metas-products'));  
            }
            document.addEventListener('rebuy.ready', function(event){
              Scrollbar.init(document.querySelector('.rebuy-product-grid'));    
              console.log('rebuilt scrollbar');  
              console.log('rebuy.ready event', event.detail);
          });
            
          
        }
    }
        

        
        	  $('.boost-pfs-filter-custom-sorting').find('svg').remove();
        	  $('<span class="plus-icon">+</span>').appendTo('.boost-pfs-filter-custom-sorting, .boost-pfs-filter-tree-mobile-button');


                  console.log('cart items = ' + $('.cart-item').length);
  var itemsCount = $('.cart-item:not(".gwp")').length;

//   IF THE SAMPLE IS THE ONLY ITEM LEFT IN THE CART, REMOVE IT FROM THE CART
                    if(itemsCount == '0') {

                      $('.gwp .quantity__button[name="minus"]').click();
                    }



  
         $('.facet-filters__label:contains(Sort by:)').text('Sort by');

});

   function checkGWP(gwp, requiredProducts, requiredProductCount, requiredMinimumSpend) {
     var requiredProductCount = requiredProductCount;
      var requiredMinimumSpend = requiredMinimumSpend;
     console.log(requiredProductCount);
              $.ajax({
        type: 'GET',
        url: '/cart.js',
          dataType: 'json', 
         success: function (data) { 
            console.log(requiredProducts);     
           var requiredProductsCheck = [];
           var sample = '';
           var cartItems = data.items;
            var total_price = data.total_price / 100;
           console.log('total price = ' + total_price);
           console.log('minimum spend = ' + requiredMinimumSpend);
          console.log('required product count = '+ requiredProductCount)
          console.log(cartItems);
           cartItems.forEach(function(item) {
              var itemQuantity = item.quantity;
             if(item.id == gwp) {
            
				sample = 'true';
               return false;
             } else {
             }
             
            if($.inArray(item.id, requiredProducts) !== -1) {
              for (i = 1; i <= itemQuantity; i++) {
                requiredProductsCheck.push('true');
              }
            }
            
          
           });
           if(sample !== 'true' && requiredProductsCheck.length == requiredProductCount && total_price > requiredMinimumSpend ) {
           			  $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {
                  quantity: 1,
                  id: gwp
                },
                  dataType: 'json', 
                 success: function (data) { 
                    console.log('added');
                 } 
               });
             } else if(sample == 'true' && requiredProductsCheck.length < requiredProductCount || total_price < requiredMinimumSpend ) {
             
            console.log('required product length = ' + requiredProductsCheck.length);
            console.log('required product count = ' + requiredProductCount);
          $('.cart-item.gwp .quantity__button[name="minus"]').click();
             console.log('removed');
                        
           }
          console.log('number of required products in cart = ' + requiredProductsCheck.length);
         } 
         });
     
      }

$('variant-selects select').on('change', function() {
  var val = $(this).val();
  $('.product-form__buttons .price-item--regular').html(val);
});

$(document).on('click', 'button.continue-shopping', function() {
  Rebuy.SmartCart.hide();
  console.log('hide smartcart');
});

// if the screen loads or resizes and is larger than 640px then remove the slick slider
$(window).on("load resize", function (e) {
// if screen is larger than 640px
if ($(window).width() > 640) {
  $('.sales-ingredients.small-icons').detach().insertAfter('.product__info-container');
}
});

// when someone clicks on a button with the href of #atc, click the form button with the name of submit
$(document).on('click', 'a[href="#atc"]', function() {
  $('form button.product-form__submit').click();
} );



// CODE FROM A/B TESTING TEAM

(function () {

  function waitForEle(predicate, success, error){

      var int = setInterval(function(){

          if(predicate()){

              clearInterval(int);

              int = null;

              success();

          }

      }, 33);

      setTimeout(function(){

          if(int !== null){

              clearInterval(int);

              if(typeof(error) === 'function'){

                  error();

              }

          }

      }, 10000);

  }



  waitForEle(function () {

      return typeof $ === "function" && $('.product .product__info-wrapper a.text-m').length > 0;

  }, function () {

    $('body').addClass('DH_PDP_04');

    $('.benefits-section').insertBefore('.row__subscription');

    $('.row__subscription').insertAfter('.product-form__input')

    $('.benefits-section').unwrap();

    if($('.product__info-wrapper span.yotpo-stars span.sr-only').text().replace(' star rating', '').indexOf('0.0')!=-1){

      $('.product__info-wrapper .yotpo-display-wrapper').addClass('hide-ratings');

    }

    var ratingHtm = $('.product__info-wrapper span.yotpo-stars span.sr-only').text().replace(' star rating', '');

    $('.product .product__info-wrapper span.yotpo-stars').after('<span class="ratingNumber">('+ratingHtm+')</span>');



    function customGaTracking(category, action, label) {

        var checkIfGaReady = setInterval(function() {

            if (typeof ga == "function" && typeof ga.getAll == "function") {

                if ("ga" in window) {

                    for (var x in ga.getAll()) {

                        if (ga.getAll()[x].model.data.ea[':trackingId'] == 'UA-157304476-1') {

                            clearInterval(checkIfGaReady);

                            tracker = ga.getAll()[x];

                            if (tracker)

                                tracker.send("event", category, action, label, {

                                    nonInteraction: true

                                });

                        }

                    }

                }

            }

        }, 100);

    }



    $('body').on('click', '.product__info-wrapper button.product-form__submit', function() {

      customGaTracking('PDP', 'AddTocart', 'AddTocartClick_DH_PDP_04');

  });

});

})();

(function () {
  function waitForEle(predicate, success, error){
      var int = setInterval(function(){
          if(predicate()){
              clearInterval(int);
              int = null;
              success();
          }
      }, 33);
      setTimeout(function(){
          if(int !== null){
              clearInterval(int);
              if(typeof(error) === 'function'){
                  error();
              }
          }
      }, 10000);
  }

  waitForEle(function () {
      return document.querySelectorAll('ul#product-grid li.grid__item ').length > 0;
  }, function () {
    document.querySelector('body').classList.add('dh_collection07');
  });
})();

// once the page is fully loaded, remove the class disabled from the a.header__icon
$(window).on('load', function() {
  // settimeout of 1 second
  setTimeout(function() {
    // remove the class disabled from the a.header__icon
      $('a.header__icon').removeClass('disabled');
  }, 1000);
}
);

document.addEventListener('rebuy:cart.change', (event) => { 

  
});

document.addEventListener('rebuy:smartcart.product-removed', (event) => {
  const smartcart = event.detail.smartcart;

  setTimeout(function() {
    console.log('rebuy:smartcart.product-removed: smartcart', smartcart.cart);
      let hasItems = window.Rebuy.SmartCart.hasItems();
      let count = window.Rebuy.SmartCart.itemCount();
      let productTitle = smartcart.cart.items[0].title;
      let lastProduct = smartcart.cart.items[0];
      console.log(productTitle);
      if (count == 1 && productTitle.includes('Sample')) {
        window.Rebuy.SmartCart.removeItem(lastProduct);
      }

  }, 500);

});